import React from "react";
import Framework from "@beardeddevops/react.framework";
import {confirmAlert} from "react-confirm-alert";
import {Objects, Parts, Types} from "components";
import APPCONFIG from "constants/Config";
import ObjectOverride from "components/ObjectOverride";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button, ButtonGroup} from "reactstrap";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";
import UniversalModalOverride from "../UniversalModalOverride";
import Tooltip from "@material-ui/core/Tooltip";

class LocationDetail extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations._name);
		this.originalType = '';
		this.state.original_subscriptions = null;
		this.state.trial_error = false;
		this.state.locationArchive = false;
	}

	/**
	 * @param {Locations_Object} data
	 */
	loadSelfAfter(data) {
		this.originalType = data.type;
		if (data.subscriptions && data.subscriptions_special && data.type === data.subscriptions_special.id) {
			let ogPkey = data.subscriptions.pkey;
			let originalSubscriptions = {...data.subscriptions, ...data.subscriptions_special};
			originalSubscriptions.pkey = ogPkey;
			this.setState({
				original_subscriptions: originalSubscriptions
			})
		}
	};

	handleAutoSend = async (property, value)=>{
		this.handleTextFieldPropertyUpdate(property,value);
		// this.model.object.pdf_save_server = this.state.pdf_save_server;
		// console.log('this', this.state, this.model);
		// this.setState({
		// 	[property]: value,
		// 	[property + '_error']: '',
		// });
		//
		// this.state.pkey ? await super.handleSubmit() : null;
	};

    handleDaysOpen = (e) => {
    	let days = this.state.days_open? this.state.days_open.split(","):["1","2","3","4","5"];
    	let day = e.currentTarget.value
    	if (days.includes(day))days = days.filter(e=>e!==day)
	    else days.push(day)
	    this.setState({days_open:days.join()});
	    this.state.pkey ? this.handleSubmit() : null;
   };

   findDays = (day) => {
    	let days_open = this.state.days_open
        return days_open.length !==0?!days_open.includes(day): day === "0" || day === "6"
   };

	handleSubmit = () => {
		super.handleSubmit();
	};

	ignoreWarning = (warningName) => () => {
		//Function needs to run AFTER the state has confirmed changed
		//Otherwise it hits with the wrong data being read in that function
		this.setState({
			[warningName]: false
		});
	};

	getFflLicenseImageWarningDismissKey = () => {
		let object = this.state;
		if (!object.binary_id || !object.pkey || !object.ffl_license_image_warning_ffl_updated) {
			return null;
		}

		return `fflboss.location.${object.binary_id}-${object.pkey}.ffl_license_image_warning.${object.ffl_license_image_warning_ffl_updated}`;
	};

	isFflLicenseImageWarningDismissed = () => {
		let dismissKey = this.getFflLicenseImageWarningDismissKey();
		if (!dismissKey) {
			return false;
		}

		try {
			return window.localStorage.getItem(dismissKey) === 'true';
		} catch (e) {
			return false;
		}
	};

	dismissFflLicenseImageWarning = () => {
		let dismissKey = this.getFflLicenseImageWarningDismissKey();
		try {
			if (dismissKey) {
				window.localStorage.setItem(dismissKey, 'true');
			}
		} catch (e) {
		}

		this.setState({
			ffl_license_image_warning: false
		});
	};

	formatFflLicenseWarningDate = () => {
		let updatedAt = this.state.ffl_license_image_warning_ffl_updated;
		if (!updatedAt) {
			return 'recently';
		}

		let updatedDate = new Date(updatedAt.replace(' ', 'T'));
		if (Number.isNaN(updatedDate.getTime())) {
			return updatedAt;
		}

		return updatedDate.toLocaleDateString();
	};

	contactSupport = () => {
		const message = (
			<div>
				If you are interested in changing the subscription for this location, contact Support by submitting a ticket at <a href='https://fflsoftwarepro.freshdesk.com/support/tickets/new'>FFL Boss Support</a>.
			</div>
		);
		confirmAlert({
			title: 'Change Subscription Details',
			message: message,
			buttons: [
				{
					label: 'Close',
					onClick: () => {
					}
				}
			]
		});
	};

	toggleLocationArchive = () => {
		this.setState({ locationArchive: !this.state.locationArchive });
	};

	handleAddData = async (data_amount) => {
		this.state.additional_data = data_amount;
		this.state.serial_trace = this.state._id;
		await this.model.submit(this, 'POST_ADD_DATA_TO_LOCATION')
	};
	
	handleTextFieldPropertyUpdate = (property, value) => {
		this.setState({ [property]: value });
	};

	form = () => {
		/** @type {Locations_Properties} properties */
		let properties = this.model.properties;
		/** @type {Locations_Object} object */
		let object = this.state;
		let { loading } = this.state;
		let { rootState } = this.props;
		let subscriptions = object.subscriptions;
		if (this.state.original_subscriptions && this.originalType === object.type) {
			subscriptions = this.state.original_subscriptions;
		}

		console.log('this in render', this);
		this.state.resubscribe = !object.subscription;
		let daysBreak = window.innerWidth< 1300
		let Week =  ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
		let weekButtons = Week.map((day,i)=>{
			return (
				<Button
					value={i.toString()}
					color="primary"
					outline={this.findDays(i.toString())}
					onClick={this.handleDaysOpen}
				>
					{daysBreak? day.substring(0,3):day}
				</Button>
			);
		})

		const enterpriseSubscriptions = ['ffl_enterprise', 'ffl_enterprise_1', 'ffl_enterprise_2', 'ffl_enterprise_4', 'ffl_enterprise_05', 'ffl_enterprise_5', 'ffl_enterprise_6'];

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md-5"}>

							{/*region Location Name*/}

							<h4 className="section-title">Location Name</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Location Name"}
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Display Name"}
									property={properties.name_display}
									value={object.name_display}
									error={object.name_display_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{/*endregion*/}

							{/*region Federal Firearms License*/}

							<h4 className="section-title">Federal Firearms License</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"FFL Number"}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									update={this.handleTextFieldPropertyUpdate}
									InputProps={{
										inputComponent: Framework.Masks.FFL,
									}}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.ffl_type}
									value={object.ffl_type}
									error={object.ffl_type_error}
									text={'type-name'}
									limit={null}
									label={"FFL Type"}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.ffl_class}
									value={object.ffl_class}
									error={object.ffl_class_error}
									text={'class-description'}
									limit={null}
									default={{value: 4, label: "None - Not a SOT"}}
									label={"FFL Class"}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"EIN Number"}
									property={properties.ein}
									value={object.ein}
									error={object.ein_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{/*endregion*/}

							{/*region CLEO Information*/}

							<h4 className="section-title">CLEO Information</h4>
							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Officer Name"}
											property={properties.cleo_name}
											value={object.cleo_name}
											error={object.cleo_name_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Agency Name"}
											property={properties.cleo_agency}
											value={object.cleo_agency}
											error={object.cleo_agency_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									label={"Email"}
									property={properties.cleo_email}
									value={object.cleo_email}
									error={object.cleo_email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Address"}
									property={properties.cleo_address}
									value={object.cleo_address}
									error={object.cleo_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'form-group '}>
								<div className={'row'}>
									<div className={'col-6 '}>
										<span className="input-label">Auto Send to CLEO</span>
									</div>
									<div className={'col-6 text-right'}>
										<Framework.Elements.ButtonSwitch
											property={properties.cleo_auto_send}
											value={object.cleo_auto_send}
											error={object.cleo_auto_send_error}
											update={this.handleAutoSend}
										/>
									</div>
								</div>
							</div>
							<h4 className="section-title">Days Open</h4>
							<div className={"form-group"} style={{textAlign: 'center'}}>
								<ButtonGroup variant="contained" color="primary" aria-label="contained primary button group">
									{weekButtons}
								</ButtonGroup>
							</div>


							{(object.has_bound_book_07_module || object.has_manufacturing_module) &&
								<h4 className="section-title">Use 07 Bound Book</h4>
							}
							{(object.has_bound_book_07_module || object.has_manufacturing_module) &&
								<div className={'row'}>
									<div className={'col-6 '}>
										<span className="input-label" style={{marginLeft: '5px'}}>Use 07 Bound Book</span>
									</div>
									<div className={"form-group"}>
										<Framework.Elements.ButtonSwitch
											property={properties.bound_book_07}
											value={object.bound_book_07}
											error={object.bound_book_07_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'On'}
											labelFalse={'Off'}
										/>
									</div>
								</div>
							}

							{/*endregion*/}
						</div>

						<div className={"col-md-3"}>

							<h4 className="section-title">Subscription Details</h4>

							{subscriptions &&
								<div className={"pricing hover-effect"} dangerouslySetInnerHTML={{__html: subscriptions.code}}/>}

							<div className="form-group">
								<Tooltip
									disableHoverListener={!this.state._id}
									interactive
									placement="top"
									classes={{tooltip: 'locationSubscriptionTooltip'}}
									title={
										<span>
											Location subscriptions are now managed in FFL Boss Marketplace.{' '}
											<a href="/accounts/market_place">Open Marketplace</a> to review plans and change this location&apos;s subscription.
										</span>
									}
								>
									<div className={this.state._id ? 'locationSubscriptionSelect--managed' : ''}>
										<Framework.Elements.Select
											disabled={Boolean(this.state._id) || enterpriseSubscriptions.includes(subscriptions.id)}
											id={'id'}
											limit={null}
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.type}
											value={object.type}
											error={object.type_error}
											object={subscriptions}
											filter={
												/** @param {Subscriptions_Properties} option */
													(option) => this.state._id ? !this.state.subscriptions.id.includes('ent') ? !option.id.includes('ent') : option : !option.id.includes('ent')
											}
											text={'description(price'}
										/>
									</div>
								</Tooltip>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Subscription ID"}
									property={properties.subscription}
									value={object.subscription}
									error={object.subscription_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={!rootState.isAdmin}
								/>
							</div>
							{enterpriseSubscriptions.includes(subscriptions.id) ?
								<div>
									<Button
										color="primary"
										onClick={this.contactSupport}
									>Contact Support</Button>
								</div> : null}
							<br></br>

								<div>
									<h4 className="section-title">Enable 4473 Cloud Storage</h4>
									<div className="form-group">
										Store all your signatures and transactions associated with 4473's on the cloud for instant access 24/7. To comply with ATF Ruling 2022-01 Electronic Storage requirements, you must also subscribe to <a href="https://app.fflboss.com/accounts/market_place" rel="noopener noreferrer">FFL Boss Cloud</a>.
									</div>
									<div className="form-group">
											<div className={'form-group '}>
												<div className={'row'}>
													<div className={'col-6 '}>
														<span className="input-label">4473 Cloud Storage</span>
													</div>
													<div className={'col-6 text-right'}>
														<Framework.Elements.ButtonSwitch
															property={properties.pdf_save_server}
															value={object.pdf_save_server}
															error={object.pdf_save_server_error}
															update={this.handleAutoSend}
															disabled={!!object.on_cloud}
														/>
													</div>
													{object.on_cloud &&
														<div className={'col-6 '}>
														<span className="input-label">Auto On when subscribed to FFLCloud</span>
														</div>}
												</div>
											</div>

									</div>
								</div>
							<Objects.DropBoxConnect
								url={'locations/' + object._id + '#details'}
							/>
						</div>


						<div className={"col-md-4"}>

							<h4 className="section-title">Contact Information</h4>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									label={"Phone Number"}
									property={properties.phone}
									value={object.phone}
									error={object.phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									label={"Fax Number"}
									property={properties.fax}
									value={object.fax}
									error={object.fax_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									label={"Email"}
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								hasCounty={true}
							/>

							{/*#region License Image Upload*/}
							<h4 className="section-title">License Image Upload</h4>

							{object.ffl_license_image_warning && !this.isFflLicenseImageWarningDismissed() &&
								<WarningAlert
									onAlertDismiss={this.dismissFflLicenseImageWarning}
									warningMessage={`This location's FFL number was updated on ${this.formatFflLicenseWarningDate()}, but the license image has not been updated since then. You may be using an old license image.`}
									noIgnore={"Dismiss"}
								/>}

							<div className={"form-group"}>
								<p>
									Upload a copy of your FFL License for future reference and
									verification.<br/>
									{object.ffl_license ?
										<span>Current Image - <b>{object.ffl_license}</b><br/><i>Upload a new
											file to
											replace the old one.</i></span>
										: null}
								</p>
								<Framework.Elements.DropZone
									property={properties.ffl_license}
									value={object.ffl_license}
									error={object.ffl_license_error}
									update={this.handleFileChange}
								/>
							</div>
							{object.ffl_license && <div>
								<img
									src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/locations/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.ffl_license.split('.')[0]}
									alt={object.ffl_license}
									style={{maxWidth: '100%'}}
								/>
							</div>}

							{this.props.rootState.hasTwinCityPawnModule ?
								<span>
									<h4 className="section-title"> Location IP Address</h4>

									<div className="form-group">
										<Framework.Elements.TextField
											label={"Address"}
											property={properties.ip_address}
											value={object.ip_address}
											error={object.ip_address_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</span>
								: null}
							{/*#endregion*/}

						</div>

					</div>

				</fieldset>
				{this.state.trial_error && <WarningAlert
					onAlertDismiss={this.ignoreWarning('trial_error')}
					warningMessage={'This location has already had a free trial and is not eligible for another trial.'}
				/>}
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		/** @type {Locations_Object} object */
		let object = this.state;
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'space-between', padding: '14px'}}>
					<UniversalModalOverride
						id={this.props.id}
						locations={rootState.locations}
						history={this.props.history}
						name={"Location Archive"}
						object={Objects.LocationArchive}
						toggle={this.state.locationArchive}
						reportClose={this.reportClose('locationArchive')}
						size={"lg"}
						submitLabel={"Archive & Delete"}
						title={"Archive & Delete"}
						hideGoTo={true}
					/>
					<Button color="danger" onClick={() => this.toggleLocationArchive()}>Archive & Delete</Button>
					<Button color="primary" onClick={this.handleSubmit}>{this.state.resubscribe ? (!object.subscription && !object.subscription_old?'Subscribe':'Resubscribe') : 'Save'}</Button>
				</CardActions>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(LocationDetail);
